import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter  } from '@angular/core';
import { Table } from 'primeng/table';
import { Administradora } from 'src/app/admihair/api/dto/administradora';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';

@Component({
  selector: 'app-usuario-franquia-rfarias-listar',
  templateUrl: './usuario-franquia-rfarias-listar.component.html',
  styleUrls: ['./usuario-franquia-rfarias-listar.component.scss']
})
export class UsuarioFranquiaRfariasListarComponent implements OnInit {

  loading: boolean = false;
  @Output() emissor = new EventEmitter();
  @Input() administradora?: Administradora;
  usuarios: Usuario[] = [];
  
  @ViewChild('filter') filter!: ElementRef;

  constructor(private usuarioService: UsuarioService) { }

  ngOnInit(): void {
    this.listarUsuarios();
  }

  listarUsuarios() {
    this.usuarioService.listarPorAdministradoraId(this.administradora?.id).subscribe({
      next: (data: Usuario[]) => {
        this.usuarios = data;
      },
      error: (err: any) => console.log(err)
    });
  }

  editar(id: number){
    this.emissor.emit({
      modo: 'EDITAR',
      id: id
    })
  }

  detalhar(id: number){
    this.emissor.emit({
      modo: 'DETALHAR',
      id: id
    })
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

}
